import { ValidatorFn } from '@angular/forms'

export function cptCodeValidator(): ValidatorFn {
  return (control) => {
    const code = control.value
    const isValid = typeof code === 'string' && code.length === 5 && /^[a-zA-Z0-9]\d\d\d[a-zA-Z0-9]$/.test(code)

    return isValid ? null : { invalidCptCode: true }
  }
}
